<template>
    <div class="lime-body">
        <div class="container">
            <div class="row">
              <loading :active.sync="isLoading" 
                  :can-cancel="true" 
                  :is-full-page="fullPage">
              </loading>
              <div class="col-md-12">
                      <nav aria-label="breadcrumb">
                          <ol class="breadcrumb breadcrumb-separator-1">
                              <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                              <li class="breadcrumb-item active" aria-current="page">Admin Profile</li>
                          </ol>
                      </nav>
                      <div style="text-align:center"><flash-message class="myCustomClass"></flash-message></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <form name="userform" @keyup.enter="save()">
                  <div class="card profile">
                      <div class="card-body center">
                      <p style="color:red;text-align:center">{{ errorMessageUserForm }}</p>
                          <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
                          </p>
                          <h5 class="card-title">Admin Detail</h5>
                              <div class="form-group">
                                  <div class="value">
                                      <!-- <label>Email :</label> -->
                                      <!-- <span>{{userDetails.email}}</span> -->
                                  </div>
                                  <input class="form-control" ref="email" type="text" name="email" id="email" v-model="userDetails.email" placeholder="Enter Email" />
                              </div>
                              <div class="form-group">
                                  <div class="value">
                                      <!-- <label>User Name :</label>
                                      <span>{{userDetails.name}}</span> -->
                                  </div>
                                  <input class="form-control" ref="username" type="text" name="username" id="username" v-model="userDetails.username" placeholder="Enter User Name" />
                              </div>
                              <div class="form-group">
                                  <input class="form-control" ref="firstname" name="firstname" id="firstname" v-model="userDetails.firstname" placeholder="FirstName" />
                              </div>
                               <div class="form-group">
                                  <input class="form-control" ref="lastname" name="lastname" id="lastname" v-model="userDetails.lastname" placeholder="LastName" />
                              </div>   
                               <div class="col-md-12" style="text-align: center;">
                                  <button type="button" class="btn btn-primary" v-on:click="save()">Save</button>
                              </div>                               
                              <!-- <button class="btn btn-secondary">Cancel</button> -->  
                      </div>
                  </div>
                </form> 
              </div>


           
              <div class="col-md-6">
                <div class="card profile">
                 <form name="passwordform" @keyup.enter="changepassword()">
                  
                      <div class="card-body center">
                      <p style="color:red;text-align:center">{{ errorMessage }}</p>
                          <p style='color:red;text-align:center' v-for="error in errorsPassword"> {{ error }}</p>
                          </p>
                          <h5 class="card-title">Password Reset</h5>
                          <div class="form-group">
                              <input class="form-control" ref="currentpass" type="password" name="currentpass" id="currentpass" v-model="currentpass" placeholder="Current Password*" />
                          </div>
                          <div class="form-group">
                              <input class="form-control" ref="newpass" type="password" name="newpass" id="newpass" v-model="newpass" placeholder="New Password*" />
                          </div>
                          <div class="form-group">
                              <input class="form-control" ref="confpass" type="password" name="confpass" id="confpass" v-model="confpass" placeholder="Confirm Password*" />
                          </div>
                          <div class="col-md-12" style="text-align: center;">
                                  <button type="button" class="btn btn-primary" v-on:click="changepassword()">Change Password</button>
                          </div>    
                      </div>  
                
                  </form> 
                 </div>
              </div>
            </div>  
        </div>
    </div> 
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
require('vue-flash-message/dist/vue-flash-message.min.css')
export default {
  name: 'UserProfile',
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      errorMessageUserForm: '',
      errors: [],
      stripe_bank_account_id: '',
      errorsPassword: [],
      msg: 'Dashboard',
      userDetails: {
        username: '',
        firstname: '',
        lastname: '',
        email: ''
      },
      currentpass: '',
      newpass: '',
      confpass: ''
    }
  },
  methods: {
    changepassword () {
      this.errorsPassword = []
      var jwttoken = localStorage.getItem('jwt')
      var userid = localStorage.getItem('uid')
      var currentpassword = this.currentpass
      var password = this.newpass
      var confirmpassword = this.confpass
      if (currentpassword === '') {
        this.errorsPassword.push('Current password is Required')
        this.$refs.currentpass.focus()
      } else if (password === '') {
        this.errorsPassword.push('New Password is Required')
        this.$refs.newpass.focus()
      } else if (password.length < 6) {
        this.errorsPassword.push('New Password must be 6 characters long')
        this.$refs.newpass.focus()
      } else if (confirmpassword === '') {
        this.errorsPassword.push('Confirm Password is Required')
        this.$refs.confpass.focus()
      } else if (password !== confirmpassword) {
        this.errorsPassword.push('Password & Confirm Password does not matched')
        this.$refs.confpass.focus()
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/changeUserPassword',
          {
            user_id: userid,
            current_password: currentpassword,
            password: password,
            confirm_password: confirmpassword
          }, {
            headers: {
              'x-access-token': jwttoken
            }})
          .then(response => {
            this.isLoading = false
            console.log(response)
            this.flash('Password Changed Successfully', 'success', {
              timeout: 1000,
              beforeDestroy () {
                location.reload()
              }
            })
          })
          .catch((error) => {
            this.errorMessage = error.response.data.errors
            this.isLoading = false
          })
      }
    },
    save () {
      this.errors = []
      var jwttoken = localStorage.getItem('jwt')
      var userid = localStorage.getItem('uid')
      var firstname = this.userDetails.firstname
      var lastname = this.userDetails.lastname
      var email = this.userDetails.email
      var username = this.userDetails.username
      if (email === '') {
        this.errors.push('Email is Required')
        this.$refs.email.focus()
      } else if (!this.emailValidator.validate(email)) {
        this.errors.push('Invalid contact Email')
        this.$refs.email.focus()
      } else if (username === '') {
        this.errors.push('Username is Required')
        this.$refs.username.focus()
      } else if (firstname === '') {
        this.errors.push('Name is Required')
        this.$refs.firstname.focus()
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/updateUserProfile',
          {
            user_id: userid,
            firstname: firstname,
            lastname: lastname,
            email: email,
            username: username
          }, {
            headers: {
              'x-access-token': jwttoken
            }})
          .then(response => {
               this.isLoading = false
               this.flash('Admin Updated Successfully', 'success', {timeout: 3000 });
            }).catch(function(error) {
                 this.isLoading = false
                 this.flash(error, 'error', {timeout: 3000 });
              });
      }
    },
   updateBankDetail () {
      var uid = localStorage.getItem('uid')
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/expressLogin/?uid=' + uid, {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          console.log(response)
          this.isLoading = false
          this.responseUrl = response.data.results.url
        })
        .catch((error) => {
          console.log(error)
          this.isLoading = false
        })
    }, 
    expressLogin () {
       window.open('https://connect.stripe.com/express/oauth/authorize?response_type=code&client_id=ca_GVYn1wmqiX7xBr65utC44cXRFRMirGLR&scope=read_write#/', '_self') 
    } 
  },  
  mounted () {
    var userRecord = JSON.parse (localStorage.getItem('user'))    
    this.stripe_bank_account_id =  userRecord.stripe_bank_account_id
    var uid = localStorage.getItem('uid')
    var jwttoken = localStorage.getItem('jwt')

    this.isLoading = true
    axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getUserProfile?uid=' + uid, {
      headers: {
        'x-access-token': jwttoken
      }})
      .then(response => {
        this.isLoading = false
        this.userDetails = response.data.results[0]
        localStorage.setItem('username', this.userDetails.name)
      })
      .catch((error) => {
        console.log(error)
        this.isLoading = false
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminProfile.vue